/**
 * Select a Target Project.
 */
import React from 'react';
// @todo: Migrate to 'Select' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import Select from 'react-select';

import * as S from './SelectComponents.styles';

export type ProjectOption = {
  value: string;
  label: string;
};

type SelectProjectProps = {
  options: ProjectOption[];
  onSelectProject: (option: ProjectOption) => void;
};

const OptionLabel = ({label}: ProjectOption) => (
  <S.SelectOption>
    <S.SelectOptionLabel>{label}</S.SelectOptionLabel>
  </S.SelectOption>
);

const SelectProject: React.FC<SelectProjectProps> = ({
  options,
  onSelectProject,
}) => {
  const onChange = (option: ProjectOption | null) => {
    if (option != null) {
      onSelectProject(option);
    }
  };
  return (
    <Select
      options={options}
      formatOptionLabel={OptionLabel}
      placeholder="Select a Target Project..."
      onChange={onChange}
    />
  );
};

export default SelectProject;
